module.exports = __webpack_public_path__ + "static/tax-mobile-plp-1da15bf6b3acb0b612b421fbc3549f2b.png";